/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateSupplierDto = {
    /**
     * Supplier name
     */
    name?: string;
    /**
     * Supplier address
     */
    address?: string;
    /**
     * Supplier phone
     */
    phone?: string;
    /**
     * Supplier email
     */
    email?: string;
    /**
     * Contact person name
     */
    contactPerson?: string;
    /**
     * Supplier description
     */
    description?: string;
    /**
     * Supplier status
     */
    status?: UpdateSupplierDto.status;
    /**
     * Source of creation
     */
    source?: UpdateSupplierDto.source;
};
export namespace UpdateSupplierDto {
    /**
     * Supplier status
     */
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
    }
    /**
     * Source of creation
     */
    export enum source {
        CATALOG = 'CATALOG',
        SETTINGS = 'SETTINGS',
    }
}

